module.exports = __webpack_public_path__ + "img/logo-withe.7d94b2ed.png";